import React, { FC } from 'react';
import { Chocolate1 } from '~/assets';
import { Button, If, Section } from '~/components/Atoms';
import {
  Left,
  Right,
  Title,
  Text,
  ImageWrapper,
  ContentWrapper,
  ButtonWrapper,
  CustomImage,
  TextWrapper,
} from './styles';

export type FrameProps = {
  title?: string;
  text?: string;
  imageSrc?: string;
  /**
   * Should image be rendered on the left side of the section?
   */
  imageLeft?: boolean;
  buttonText?: string;
  customMedia?: JSX.Element;
  id?: string;
  isShowing?: boolean;
  expand?: boolean;
  fitContentHeight?: boolean;
};

const Frame: FC<FrameProps> = ({
  text = 'Portfólio amplo de doces que cobrem até mesmo os requisitos mais exigentes de sua festa',
  title = 'Docinhos em um outro nível',
  imageLeft = false,
  imageSrc = Chocolate1,
  buttonText,
  customMedia,
  id,
  isShowing = false,
  expand = true,
  fitContentHeight,
}) => {
  return (
    <Section id={id} fitContentHeight={fitContentHeight}>
      <ContentWrapper
        isShowing={isShowing}
        imageLeft={imageLeft}
        expand={expand}
      >
        <Left
          buttonText={!!buttonText}
          imageLeft={imageLeft}
          isShowing={isShowing}
        >
          <Title>{title}</Title>
          <TextWrapper>
            <Text>{text}</Text>
          </TextWrapper>
          <If condition={!!buttonText}>
            <ButtonWrapper>
              <Button btnText={buttonText} />
            </ButtonWrapper>
          </If>
        </Left>
        <Right isShowing={isShowing}>
          <If condition={!customMedia}>
            <ImageWrapper>
              <CustomImage src={imageSrc} />
            </ImageWrapper>
          </If>
          <If condition={!!customMedia}>{customMedia}</If>
        </Right>
      </ContentWrapper>
    </Section>
  );
};

export default Frame;
